import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetInquiries, IGetInquiry, IInquiryParams } from '../models/boardParentsQna.model';
import QueryString from 'qs';

const uri = '/mgmt/board/parentsQna';

export const getInquiries = (): AxiosPromise<IGetInquiries> => {
  return axios.get(uri);
}

export const getInquiriesByParameter = (params: IInquiryParams): AxiosPromise<IGetInquiries> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
}

export const getInquiry = (qnaCode: number): AxiosPromise<IGetInquiry> => {
  return axios.get(`${uri}/${qnaCode}`);
}

export const createInquiry = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateInquiry = (qnaCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${qnaCode}`, data);
};

export const createAnswer = (qnaCode: number, data: FormData): AxiosPromise => {
  return axios.post(`${uri}/answer/${qnaCode}`, data);
};

export const updateAnswer = (qnaCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/answer/${qnaCode}`, data);
};
